(function () {
  'use strict'

  // eslint-disable-next-line no-undef
  angular.module('MktzapApp.Controllers').controller('SupportedMediasController', SupportedMediasController)

  SupportedMediasController.$inject = ['$rootScope', 'CompanyService', 'NotificationService']

  function SupportedMediasController ($rootScope, CompanyService, NotificationService) {
    $rootScope.getPageLabels('menu.config.supportedMedias')

    var vmSupportedMediasCtrl = this

    CompanyService
      .loadMetadata()
      .$promise
      .then(function (data) {
        vmSupportedMediasCtrl.metadata = data
        vmSupportedMediasCtrl.metadata.allow['audio_allowed'] = checkAllowedMedia(vmSupportedMediasCtrl.metadata.allow['audio_allowed'])
        vmSupportedMediasCtrl.metadata.allow['video_allowed'] = checkAllowedMedia(vmSupportedMediasCtrl.metadata.allow['video_allowed'])
      })
      .catch(function (error) {
        NotificationService.errorHandler(error, $rootScope.labels.errorLoadMeta)
      })

    vmSupportedMediasCtrl.allow = function () {
      CompanyService
        .saveMetadata(vmSupportedMediasCtrl.metadata)
        .$promise
        .then(function (data) {
          $rootScope.company_metadata = data
          NotificationService.successHandler(data, $rootScope.labels.saveConfig)
        })
        .catch(function (error) {
          NotificationService.errorHandler(error, $rootScope.labels.errorConfig)
        })
    }

    function checkAllowedMedia (allowed = true) {
      return allowed
    }
  }
// eslint-disable-next-line semi
})();
